module.exports = __webpack_public_path__ + "static/media/arrow-down-icon.502b9100.png";